const e = {
  name: "PlayFilled",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25,20L18,24.2v-8.5L25,20z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20c0,11-9,20-20,20C9,40,0,31,0,20z M28.9,20L16,12.2v15.5L28.9,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as PlayFilled
};
